export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;
export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;

// Values you may additionally want to configure globally
export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION;
export const amcPixelUrl = process.env.NEXT_PUBLIC_AMC_PIXEL_URL;
export const isDevMode =
  process.env.NEXT_PUBLIC_GTM_DEV_MODE?.toLowerCase() === "true";
